import { Controller } from "@hotwired/stimulus"

// Controller to auto-fill the HydrationDatum value field based on the selected key's default_value.
// Behavior:
// - On connect: if the value field is empty and a key is selected, fill with its default_value.
// - On key change: if the value field is empty, fill with the selected key's default_value.
// - Never overwrite non-empty user-entered values.
export default class extends Controller {
  static values = {
    defaults: String, // JSON string mapping { key: default_value }
    keySelector: { type: String, default: "[data-hydration-form-key-select=\"true\"]" }
  }

  connect() {
    this.keySelect = document.querySelector(this.keySelectorValue)
    this.defaults = {}
    try {
      if (this.hasDefaultsValue && this.defaultsValue && this.defaultsValue.length > 0) {
        this.defaults = JSON.parse(this.defaultsValue)
      }
    } catch (e) {
      this.defaults = {}
    }

    // Initial prefill on load
    this.prefillIfBlank()

    // Attach listener if not already connected
    if (this.keySelect) {
      this.boundHandler = this.boundHandler || this.keySelected.bind(this)
      this.keySelect.addEventListener("input", this.boundHandler)
      this.keySelect.addEventListener("change", this.boundHandler)
    }
  }

  disconnect() {
    if (this.keySelect && this.boundHandler) {
      this.keySelect.removeEventListener("input", this.boundHandler)
      this.keySelect.removeEventListener("change", this.boundHandler)
    }
  }

  keySelected() {
    this.prefillIfBlank()
  }

  prefillIfBlank() {
    // this.element is the value textarea input
    const valueInput = this.element
    if (!valueInput) return

    const current = (valueInput.value || "").trim()
    if (current.length > 0) return // never overwrite non-empty input

    const selectedKey = this.keySelect ? this.keySelect.value : null
    if (!selectedKey) return

    const defaultValue = this.defaults[selectedKey]
    if (defaultValue == null || String(defaultValue).length === 0) return

    valueInput.value = defaultValue
    // Notify any listeners the value changed
    valueInput.dispatchEvent(new Event("input", { bubbles: true }))
    valueInput.dispatchEvent(new Event("change", { bubbles: true }))
  }
}

